export function base64ToBlob(base64, contentType) {
    const byteCharacters = atob(base64.split(",")[1]); // Remove base64 prefix and decode
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}

export function getURLFileName(url) {
    // Get the file name from the URL
    let fileName = url.substring(url.lastIndexOf("/") + 1);

    // Remove any non-latin characters
    const nonLatinPattern = /[^\u0000-\u007F]/;
    if (nonLatinPattern.test(fileName)) {
        fileName = transliterate(fileName);
    }

    // Replace any special characters with underscores
    fileName = fileName.replace(/[^a-zA-Z0-9.]/g, "_");

    return fileName;
}

export function isValidUrl(str) {
    const pattern = new RegExp(
        "^([a-zA-Z]+:\\/\\/)?" + // protocol
            "(?:www\\.)?[\\w\\-]+(\\.[\\w\\-]+)+" + // domain name
            "(:\\d+)?(\\/[\\w\\-%.~:+,\\(\\)]*)*" + // port, path, and parentheses
            "(\\?[\\w\\-%.~+=:;&]*)?" + // query string
            "(#[\\w\\-%.~:=&,#!'\\(\\)]*)?$", // fragment locator
        "i",
    );
    return pattern.test(str);
}
